import { requestHeaders } from '@/api';
import settings from '@/data/constants';
import { Logger } from '@/utils/logger';

const logger = new Logger('getAustralianStates.ts');

export const getAustralianStates = async () => {
  const getAustralianStatesUrl = `${settings.url}/location/states`;

  try {
    const getAustralianStatesResponse = await fetch(getAustralianStatesUrl, {
      method: 'GET',
      headers: requestHeaders()
    });

    if (!getAustralianStatesResponse.ok) {
      throw new Error(`Error: ${getAustralianStatesResponse.status}`);
    }

    const australianStates = await getAustralianStatesResponse.json();

    return australianStates;
  } catch (error) {
    logger.error('Error fetching Australian states:', error);
    throw new Error(`Failed to fetch Australian states: ${error instanceof Error ? error.message : error}`);
  }
};
